/** LinkedIn Sales Navigator strings (own file — en.ts sits on the file-length ratchet). */
export const enLiSn = {
	url: "Sales Navigator URL",
	urlPlaceholder: "Enter URL from Sales Navigator",
	name: "Name",
	currentCompany: "Current Company",
	companyHeadcount: "Company Headcount",
	pastCompanyList: "Past Companies",
	companyType: "Company Type",
	headquarterLocation: "Headquarter Location",
	companyHeadquarterLocation: "Company Headquarter Location",
	function: "Function",
	currentJobTitle: "Current Job Title",
	seniorityLevel: "Seniority Level",
	pastJobTitle: "Past Job Title",
	yearsInCurrentCompany: "Years in Current Company",
	yearsInCurrentPosition: "Years in Current Position",
	geography: "Geography",
	industry: "Industry",
	firstName: "First Name",
	lastName: "Last Name",
	profileLanguage: "Profile Language",
	yearsOfExperience: "Years of Experience",
	school: "School",
	connectionsOf: "Connections of",
	followingYourCompany: "Following Your Company",
	viewedYourProfileRecently: "Viewed Your Profile Recently",
	pastColleague: "Past Colleague",
	sharedExperiences: "Shared Experiences",
	changedJob: "Changed Job",
	postedOnLinkedin: "Posted on LinkedIn",
	mentionedInNews: "Mentioned in News",
	namePlaceholder: "Enter name",
	firstnamePlaceholder: "Enter first name",
	lastnamePlaceholder: "Enter last name",
	preview: {
		button: "Preview",
		title: "Sales Navigator Preview",
		resultsCount: "Showing {{shown}} of {{total}} results",
		empty: "No results found for these filters.",
		fallbackTitle: "Preview served by a different user",
		selectedUserNoSalesNavigatorAccess:
			"The selected scraping user does not have access to Sales Navigator.",
		organizationNoSalesNavigatorAccess:
			"No user in the current organization has access to Sales Navigator.",
		viewOnLinkedin: "View on LinkedIn",
		sharedConnections: "Shared connections",
		noPicture: "No picture",
		networkDistance: {
			DISTANCE_1: "1st",
			DISTANCE_2: "2nd",
			DISTANCE_3: "3rd+",
			OUT_OF_NETWORK: "Out of network",
		},
	},
	scrapingUser: {
		disconnected: "Disconnected",
		allDisconnectedWarning:
			"No connected user currently has Sales Navigator access. Sales Navigator scraping is paused until a licensed user reconnects Signalist with LinkedIn.",
	},
};
